import * as React from 'react';
import { IconButton, WithStyles } from '@material-ui/core';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { withStyles } from '@material-ui/core/styles';
import tablePaginationActionsWrappedStyle from './tablePaginationActionsWrappedStyle';
import translate from '@/app/utils/translate';

interface Props extends WithStyles<typeof tablePaginationActionsWrappedStyle, true> {
  onChangePage: (event: React.MouseEvent, page: number) => void;
  page: number;
  count: number;
  rowsPerPage: number;
}

const TablePaginationActions: React.FunctionComponent<Props> = (props) => {
  const handleFirstPageButtonClick = (event: React.MouseEvent) => {
    props.onChangePage(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent) => {
    props.onChangePage(event, props.page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent) => {
    props.onChangePage(event, props.page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent) => {
    props.onChangePage(
      event,
      Math.max(0, Math.ceil(props.count / props.rowsPerPage) - 1),
    );
  };

  const { classes, count, page, rowsPerPage, theme } = props;

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={translate.t('first_page')}
        title={translate.t('first_page')}
        component={'span'}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={translate.t('previous_page')}
        title={translate.t('previous_page')}
        component={'span'}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={translate.t('next_page')}
        title={translate.t('next_page')}
        component={'span'}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={translate.t('last_page')}
        title={translate.t('last_page')}
        component={'span'}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
};

const TablePaginationActionsWrapped = withStyles(tablePaginationActionsWrappedStyle, { withTheme: true })(
  TablePaginationActions,
);

export default TablePaginationActionsWrapped;
